import React, { useState, useEffect } from 'react';
import MindMapCanvas from '../components/mindmap';

function App() {
    return (
        <div>
            <MindMapCanvas />
        </div>
    );
}

export default App;
